import { useCallback } from "react"
import { setPurchasePlanIdentifiers } from "reducers/purchasePlan/purchase-plan-actions"
import { useAppDispatch } from "reducers/store"

export const usePurchasePlanIdentifiers = () => {
  const appDispatch = useAppDispatch()

  const identifiersCleanup = useCallback(() => {
    appDispatch(
      setPurchasePlanIdentifiers({
        productPrefixUrl: "",
        productId: "",
        purchasePlanId: ""
      })
    )
  }, [])

  const identifiersDefinition = useCallback((productId: string, purchasePlanId: string, productPrefixUrl = "") => {
    appDispatch(
      setPurchasePlanIdentifiers({
        productId,
        purchasePlanId,
        productPrefixUrl
      })
    )
  }, [])

  return {
    identifiersCleanup,
    identifiersDefinition
  }
}
